import _ from 'lodash';
import ApiCreativeProduction from '@/helpers/ApiCreativeProduction';

/** VUEX module for creative in Creative Production section **/

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        creatives: [],
        creativesReadyTraffic: [],
        creative: null
    },
    // -----------------------------------------------------------------
    getters: {
        list: (state, getters, rootState, rootGetters) => {

            let includingMappedData = state.creatives.map(item => {
                let itemRef = _.cloneDeep(item);

                // map field into the creative
                // itemRef.advertiser = _.get(rootGetters['advertisers/list'], `[${itemRef.advertiser_id}].name`, "");
                // itemRef.kpi = _.get(rootGetters['KPIs'], `[${itemRef.kpi_id}].name`, {});
                // itemRef.deal_type = _.get(rootGetters['dealTypes'], `[${itemRef.deal_type_id}].name`, {});
                itemRef.touched_on = itemRef.updated_date || itemRef.created_date;

                return itemRef;
            });
            
            return includingMappedData;
        },
        listByCampaignId: (state, getters, rootState, rootGetters) => id => {
            const item = getters.list.filter(item => item.external_campaign_id === id);
            return item;
        },
        listReadyForTraffic: (state, getters, rootState, rootGetters) => {
            // let _list = getters.list.map(item => {
            //     if(item.status === 'Ready For Traffic' || item.status === 3){
            //         return item;
            //     }
            // });

            let includingMappedData = state.creativesReadyTraffic.map(item => {
                let itemRef = _.cloneDeep(item);

                // map field into the creative
                // itemRef.advertiser = _.get(rootGetters['advertisers/list'], `[${itemRef.advertiser_id}].name`, "");
                // itemRef.kpi = _.get(rootGetters['KPIs'], `[${itemRef.kpi_id}].name`, {});
                // itemRef.deal_type = _.get(rootGetters['dealTypes'], `[${itemRef.deal_type_id}].name`, {});
                itemRef.touched_on = itemRef.updated_date || itemRef.created_date;

                return itemRef;
            });
            
            return includingMappedData;
            
            return _list;
        },
        itemById: (state, getters) => id => {
            let item = getters.list.find(item => item.id == id);

            return item;
        }, 
        selectedCreative: (state) => {
            return state.creative; 
        }
    },
    // -----------------------------------------------------------------
    mutations: {
        SET: (state, payload) => {
            state.creatives = payload;
            return payload;
        },
        SET_READY_FOR_TRAFFIC: (state, payload) => {
            state.creativesReadyTraffic = payload;
            return payload;
        },
        SET_BY_ID: (state, payload) => {
            state.creative = payload;
        },
        CREATE: (state, payload) => {
            state.creatives.push(payload);
        },
        UPDATE: (state, payload) => {
            const item = state.creatives.find(item => item.id === payload.id);
            if(item) Object.assign(item, payload);
            else state.creatives.push(payload);
        },
        DELETE: (state, id) => {
            let index = _.findIndex(state.creatives, {
                id: id
            })

            state.creatives.splice(index, 1);
        },
        REPLACE: (state, payload) => {
            if(state.creatives.length == 0){
                state.creatives.push(payload);
            } else {
                let index = _.findIndex(state.creatives, {
                    id: payload.id
                })

                state.creatives.splice(index, 1, payload);
            }
        },
        ADD_EVENTS: (state, payload) => {
            let index = _.findIndex(state.creatives, {
                id: payload.id
            });

            state.creatives[index].events = payload.events;

        },
        REMOVE_EVENTS: (state, payload) => {
            let index = _.findIndex(state.creatives, {
                id: payload.id
            });

            state.creatives.events.splice(index, 1);

        },
    },
    // -----------------------------------------------------------------
    actions: {
        fetch: (context) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchCreatives', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.getCreativeList()
                    .then(data => context.commit("SET", data))
                    .then(data => {
                        // app status: ready
                        context.dispatch('completeTask', 'fetchCreatives', { root: true });

                        resolve(data);
                    })
                    .catch(error => {
                        // app status: ready
                        context.dispatch('completeTask', 'fetchCreatives', { root: true });

                        reject(error);
                    });
            });
        },
        fetchReadyForTraffic: (context) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchCreativesInactive', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.getCreativeListReadyForTraffic()
                    .then(data => context.commit("SET_READY_FOR_TRAFFIC", data))
                    .then(data => {
                        // app status: ready
                        context.dispatch('completeTask', 'fetchCreativesInactive', { root: true });

                        resolve(data);
                    })
                    .catch(error => {
                        // app status: ready
                        context.dispatch('completeTask', 'fetchCreativesInactive', { root: true });

                        reject(error);
                    });
            });
        },
        
        fetchById: (context, creativeId) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchCampaign', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.getCreativeById(creativeId)
                    .then(data => {
                        context.commit("SET_BY_ID", data);
                        context.commit("UPDATE", data);
                        // app status: ready
                        context.dispatch('completeTask', 'fetchCampaign', { root: true });
                        
                        resolve(data);
                    })
                    .catch(error => {
                        // app status: ready
                        context.dispatch('completeTask', 'fetchCampaign', { root: true });

                        reject(error);
                    });
            });
        },
        model: (context, creativeData) => {
            return new Promise((resolve, reject) => {
                try {
                    let creativeDataModel = [
                        'name',
                        'campaign_id',
                        // 'external_campaign_id',
                        // 'campaign_name',
                        // 'status',
                        'status_id',
                        // 'creative_source',
                        'external_creative_id',
                        'format_id', //product
                        // 'product', // format_id
                        // 'production',//"Build Your Own",
                        // 'production_id',
                        // 'production_build_type',
                        'external_template_id',
                        'production_build_type_id',
                        'main_kpi_id',
                        'kpi_goal',
                        'kpi2_id',
                        'kpi2_goal',
                        'creative_tag',
                        'external_tag_id',
                        'creative_type_id',
                        'engagement_type',
                        'vast_tag',
                    ];

                    // if this is an existent campaign...
                    if(creativeData.id) {
                        // ... add the id to the model
                        creativeDataModel.push("id");
                        // creativeDataModel.push("modified_by");
                    } else {
                        // creativeDataModel.push("created_by");
                    }

                    // pick the values in the model from our creativeDataModel
                    let creativeDataModeled = _.pick(creativeData, creativeDataModel);

                    resolve(creativeDataModeled);
                } catch (error) {
                    reject(error);
                }

            });
        },
        create: (context, creativeData) => {

            // app status: loading
            context.dispatch('registerTask', 'createCreative', {root:true});

            return new Promise((resolve, reject) => {
                context.dispatch('model', creativeData)
                .then(creativeDataModeled => {
                    return creativeDataModeled;
                })
                .then(creativeDataModeled => ApiCreativeProduction.createCreative(creativeDataModeled))
                .then(creativeDataFromServer => {
                    // app status: ready
                    context.commit('CREATE', creativeDataFromServer);
                    // context.commit('CREATE', creativeDataFromServer.data);
                    context.dispatch('completeTask', 'createCreative', {root:true});
                    resolve(creativeDataFromServer);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'createCreative', {root:true});

                    reject(error);
                });
            });
        },
        update: (context, creativeData) => {

            // app status: loading
            context.dispatch('registerTask', 'updateCreative', {root:true});

            return new Promise((resolve, reject) => {
                context.dispatch('model', creativeData)
                .then(creativeDataModeled => {
                    return creativeDataModeled;
                })
                .then(creativeDataModeled => ApiCreativeProduction.updateCreative(creativeDataModeled))
                .then(creativeDataFromServer => {
                    // app status: ready
                    context.commit('UPDATE', creativeDataFromServer);
                    context.dispatch('completeTask', 'updateCreative', {root:true});
                    resolve(creativeDataFromServer);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'updateCreative', {root:true});

                    reject(error);
                });
            });
        },
        read: (context, id) => {
            // app status: loading
            context.dispatch('registerTask', 'readCreative', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.getCreativeById(id)
                .then(data => {
                    // app status: ready
                    context.dispatch('completeTask', 'readCreative', { root: true });
                    context.commit('SET_BY_ID', data);
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'readCreative', { root: true });

                    reject(error);
                });
            });
        },
        delete: (context, id) => {
            context.dispatch('registerTask', 'deleteCreative', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.deleteCreative(id)
                    .then(data => {
                        //Determine if we need to update the campaign here, because we are prompting the user to SAVE CAMPAIGN after syncing
                        context.commit('DELETE', id);
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        context.dispatch('completeTask', 'deleteCreative', { root: true });
                    });
            });
        },
        eventModel: (context, data) => {
            return new Promise((resolve, reject) => {
                try {
                    const modeled = data.map(item => {
                        return _.pick(item, ['event_id', 'creative_id', 'label_name']);
                    });

                    resolve(modeled);
                } catch (error) {
                    reject(error);
                }

            });
        },
        addCreativeEvents: (context, data) => {
            context.dispatch('registerTask', 'addCreativeEvents', {
                root: true
            });

            const _events = data.events.map(item => {
                return _.pick(item,  ['event_id', 'creative_id', 'label_name']);
            });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.addCreativeEvents(data.id, _events)
                    .then(response => {
                        // we need to receive all events  
                        context.commit('ADD_EVENTS', data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        context.dispatch('completeTask', 'addCreativeEvents', { root: true });
                    });
            });
        },
        // only receive an object
        removeCreativeEvents: (context, data) => {
            context.dispatch('registerTask', 'removeCreativeEvents', {
                root: true
            });

            const _event = _.pick(data.event,  ['id', 'event_id', 'creative_event_id', 'creative_id', 'label_name']);

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.removeCreativeEvents(data.id, _event)
                    .then(response => {
                        // context.commit('REMOVE_EVENTS', {id, _event});
                        // we need to receive all events  
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        context.dispatch('completeTask', 'removeCreativeEvents', { root: true });
                    });
            });
        },
        updateCreativeEvents: (context, data) => {
            context.dispatch('registerTask', 'updateCreativeEvents', {
                root: true
            });

            const _events = data.events.map(item => {
                return _.pick(item,  ['id', 'event_id', 'creative_id', 'label_name']);
            });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.updateCreativeEvents(data.id, _events)
                    .then(response => {
                        // we need to receive all events  
                        // context.commit('ADD_EVENTS', _events);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        context.dispatch('completeTask', 'updateCreativeEvents', { root: true });
                    });
            });
        },
        
        cloneCreatives: (context, data) => {
            // app status: loading
            context.dispatch('registerTask', 'cloneCreatives', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.cloneCreatives(data)
                .then(data => {
                    // app status: ready
                    context.dispatch('completeTask', 'cloneCreatives', { root: true });
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'cloneCreatives', { root: true });

                    reject(error);
                });
            });
        },

        createCreativesLogs: (context, data) => {
            // app status: loading
            context.dispatch('registerTask', 'createCreativesLogs', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.createCreativesLogs(data)
                .then(data => {
                    // app status: ready
                    context.dispatch('completeTask', 'createCreativesLogs', { root: true });
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'createCreativesLogs', { root: true });

                    reject(error);
                });
            });
        },

        fetchAirtoryCreative: (context, id) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchAirtoryCreative', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.fetchAirtoryCreative(id)
                .then(data => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchAirtoryCreative', { root: true });
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchAirtoryCreative', { root: true });

                    reject(error);
                });
            });
        },

        fetchCreativesDownload: (context, id) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchCreativesDownload', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.fetchCreativesDownload(id)
                .then(data => {
                    // app status: ready
                    // console.log('download creative', data);
                    context.dispatch('completeTask', 'fetchCreativesDownload', { root: true });
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchCreativesDownload', { root: true });

                    reject(error);
                });
            });
        },

        fetchCreativesLogs: (context, id) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchCreativesLogs', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.fetchCreativesLogs(id)
                .then(data => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchCreativesLogs', { root: true });
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchCreativesLogs', { root: true });

                    reject(error);
                });
            });
        },
        
        fetchCreativeGwdFiles: (context, id) => {
            // app status: loading
            context.dispatch('registerTask', 'getCreativeGwdFiles', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.getCreativeGwdFiles(id)
                .then(response => {
                    // app status: ready
                    console.log('getCreativeGwdFiles', response);
                    context.dispatch('completeTask', 'getCreativeGwdFiles', { root: true });
                    resolve(response);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'getCreativeGwdFiles', { root: true });

                    reject(error);
                });
            });
        },

        fetchAirtoryTag: (context, id) => {
            // app status: loading
            context.dispatch('registerTask', 'fetchAirtoryTag', { root: true });

            return new Promise((resolve, reject) => {
                ApiCreativeProduction.fetchAirtoryTag(id)
                .then(data => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchAirtoryTag', { root: true });
                    resolve(data);
                })
                .catch(error => {
                    // app status: ready
                    context.dispatch('completeTask', 'fetchAirtoryTag', { root: true });

                    reject(error);
                });
            });
        },
        
        
    }
}